import { FormEvent } from "react"

import styles from "assets/scss/index.module.scss"

import { Spinner } from "components/common/Spinner"
import { AuthForm } from "components/form/AuthForm"
import { Button } from "components/form/Button"
import { Input } from "components/form/Input"

type ForgotPasswordFormProps = {
  isFetching: boolean
  email: string
  errorField?: string
  errorMessage?: string
  onInputChange: (event: FormEvent<HTMLInputElement>) => void
  onSubmit: (event: FormEvent) => void
}

export const ForgotPasswordForm = ({
  isFetching,
  email,
  errorField,
  errorMessage,
  onInputChange,
  onSubmit,
}: ForgotPasswordFormProps) => {
  return (
    <AuthForm title="Forgot Password?" subtitle="Enter your email to reset your password." onSubmit={onSubmit}>
      <Input
        label="Email"
        placeholder="Enter email"
        name="email"
        testId="forgot-password-email"
        value={email}
        onChange={onInputChange}
        errorMessage={errorField === "email" ? (errorMessage ?? "") : ""}
      />
      <div className={styles.authButtonsWrapper}>
        <Button
          onClick={onSubmit}
          type="submit"
          disabled={isFetching}
          color="colored"
          size="fullWidth"
          testId="forgot-password-submit"
        >
          {isFetching ? <Spinner width={38} height={38} /> : "Submit"}
        </Button>
      </div>
    </AuthForm>
  )
}
